var map = {
	"./1.jpg": "P4st",
	"./10.jpg": "dKwv",
	"./11.jpg": "ENTY",
	"./12.jpg": "E3eq",
	"./13.jpg": "048d",
	"./2.jpg": "HTt/",
	"./3.jpg": "I83T",
	"./4.jpg": "XpfX",
	"./5.jpg": "uYkk",
	"./6.jpg": "tqwP",
	"./7.jpg": "+frz",
	"./8.jpg": "6hHA",
	"./9.jpg": "MySN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8TPD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/suite2 ^\.\/.*\.jpg$
// module id = 8TPD
// module chunks = 1